import React from 'react';
import FillQuestionnaire from '../../components/Questionnaire/FillQuestionnaire';

export const Questionnaire = () => {
  return (
    <FillQuestionnaire />
  );
}